import React from "react";
import {
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import "./App.css";
import {Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import AuthService from "./services/authServise";
import Header from "./components/Header";
import Info from "./views/Info";
import Devices from "./views/Devices";
import Logout from "./views/Logout";
import {Sidebar, SidebarTop} from "./components/Sidebar";
import Login from "./views/Login";
import { UserContextProvider } from "./context/userContext";
function App() {
  const authServise = new AuthService();
  const userLogged = authServise.isAuthenticated();

  const content = () => {
    return (
      <Container fluid="true" md="true">
        <Header active={userLogged} />
        <SidebarTop active={userLogged} />
        <Row className="m-0">
          <Sidebar active={userLogged} />
          <Col className="App-content">
            <Switch>
              <Redirect from="/" to="/info" exact />
              <Route path="/info" component={Info} />
              <Route path="/devices" component={Devices} />
              <Route path="/logout" component={Logout} />
              <Route path="/login" component={Login} />
              <Redirect to="/info" />
            </Switch>
          </Col>
        </Row>
      </Container>
    );
  };

  return (
    <div className="App">
      {userLogged ? (
        <UserContextProvider>{content()}</UserContextProvider>
      ) :
        (
        <Container fluid="true" md="true">
        <Header active={userLogged} />
        <Row className="m-0">
          <Sidebar id="sidebar" active={userLogged} />
          <Col className="App-content p-5">
            <Switch>
              <Redirect from="/" to="/info" exact />
              <Route path="/info" component={Info} />
              <Route path="/devices" component={Devices} />
              <Route path="/logout" component={Logout} />
              <Route path="/login" component={Login} />
              <Redirect to="/info" />
            </Switch>
          </Col>
        </Row>
      </Container>
        )}
    </div>
  );
}

export default App;
